import { Injectable } from '@angular/core';
import { LicenseLogin } from '../_interfaces/LicenseLogin';
import { ModalController } from "@ionic/angular"
import { ReleaseLicensePage } from "../_template/release-license/release-license.page"
import { HttpFunctionResult } from '../_interfaces/HttpFunctionResult';

@Injectable({
  providedIn: 'root'
})
export class LicenseService {

  constructor(
    private modalCtrl: ModalController
  ) { }

  public async releaseLicense(loginList: LicenseLogin[], resolve: (license: HttpFunctionResult<LicenseLogin>) => void){
    
    let modal = await this.modalCtrl.create({
      component: ReleaseLicensePage,
      backdropDismiss: false,
      componentProps: {licenses: loginList}
    })

    modal.onWillDismiss().then((result: any)=> resolve(result.data))

    await modal.present()

  }



}
